// Audience toggle — swaps between Individual and Team plan panels.
// Targets: [data-audience-pills] toggle buttons, [data-audience-panel] sections.

import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

export function initAudienceToggle(root = document) {
  const toggles = root.querySelectorAll("[data-audience-pills]");

  toggles.forEach((pills) => {
    if (!firstBind(pills)) return;

    const buttons = pills.querySelectorAll("[data-audience]");
    const scope = pills.closest(".animate-rise") || pills.parentElement;

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const audience = btn.dataset.audience;

        // Toggle active button style
        buttons.forEach((b) => {
          const isActive = b.dataset.audience === audience;
          b.classList.toggle("bg-white", isActive);
          b.classList.toggle("text-ink-900", isActive);
          b.classList.toggle("shadow-sm", isActive);
          b.classList.toggle("text-ink-500", !isActive);
          b.classList.toggle("hover:text-ink-700", !isActive);
        });

        // Show/hide audience panels
        scope.querySelectorAll("[data-audience-panel]").forEach((panel) => {
          if (panel.dataset.audiencePanel === audience) {
            panel.classList.remove("hidden");
          } else {
            panel.classList.add("hidden");
          }
        });
      });
    });
  });
}
